<template lang="pug">
  v-stepper(v-model="e1")
    v-stepper-header
      v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
      v-divider
      v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
      v-divider
      v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus

    v-stepper-items
      v-stepper-content(step="1")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              v-flex(xs4 sm3 style="margin-top:20px")
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Judul Pekerjaan
              v-flex(xs7 sm5 style="margin-top:20px")
                v-text-field(id="fius-judul-pekerjaan", class="inputDefault" v-model='ipJudulPekerjaan' label="Judul Pekerjaan")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3 style="margin-top:5px") 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Kontraktor / Subkontraktor
              v-flex(xs7 sm5 style="margin-top:10px")
                v-text-field(id="fius-kontraktor", class="inputDefault" v-model='ipPerusahaan' label="Kontraktor / Subkontraktor")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Lokasi Pekerjaan
              v-flex(xs7 sm5)
                v-row
                  v-col
                    v-autocomplete(
                        class="inputDefault"
                        label="Lokasi Pekerjaan" 
                        v-model="lokasi" 
                        id="fius-lokasi-pekerjaan",
                        :items="locations.data" 
                        no-data-text="No Data" 
                        color="blue-grey lighten-2" 
                        item-text="location_name" 
                        item-value="data" 
                        clearable
                        chips
                        multiple)
                  v-col
                    v-text-field(id="fius-sublokasi", class="inputDefault" v-model='ipSubLocation' counter="100" maxlength="100" label="Sub Lokasi" height="42")
              v-flex(xs1 sm4)

              
              v-flex(xs4 sm3)
                p(class="headerSection")
                  span(class="mustFill") *
                  span  Departmen / Divisi
              v-flex(xs7 sm5)
                v-row
                  v-col
                    v-autocomplete(
                      class="inputDefault"
                      v-model="ipDeptDivisi"
                      id="fius-dep-divisi",
                      :items="dataUsers.department"
                      label="Departmen")
                  v-col
                    v-text-field(id="fius-divisi", class="inputDefault" v-model='ipDivisi' counter="100" maxlength="100" label="Divisi")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") 
                  span(class="mustFill") *
                  span  Nama Pemegang Izin
              v-flex(xs7 sm5 style="margin-top:-18px")
                v-menu(
                  v-model="searchPemegangMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="pemegangIzin.name"
                      id="fius-pemegang-izin",
                      label="Pemegang Izin"
                      readonly
                      v-on="on")
                 
                  ModalIzinProyek(:searchPemegang="searchPemegangMenu" @interface="searchPemegangMenu = false" @selectedUser="updatePemegangIzin" :pemegangIzin="edit ? this.pemegangIzin : null")
              v-flex(xs1 sm4)
        v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="2")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
  
              v-flex(xs12 sm12) 
                  h3(class="headerSection") Deskripsi Detail Pekerjaan (spesifik dan tidak boleh ada tambahan kegiatan diluar cakupan yang tertera dalam izin ini)
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fius-deskripsi", :editor="editor" v-model="ipJobDescription" :config="editorConfig")
        
        v-btn(text @click="backHome()") Cancel
        v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
        v-btn(color="primary" @click="e1 = 3; scrollTop();") Continue

      v-stepper-content(step="3")
        v-card(class="mb-12"
        height="auto")
          v-layout(row wrap)
              v-flex(xs12 sm12 style="margin-bottom:25px") 
                b(class="headerSection") PENCEGAHAN/PERSYARATAN KHUSUS
              v-flex(xs5 sm6)
                  p(class="headerInput") Kontrak / PO / NOA / SI 
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-kontrak", class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipKontrak" label="Pilih" clearable) 

              v-flex(xs5 sm6)
                  p(class="headerInput") Metode Kerja 
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-metode-kerja" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipMetodeKerja" label="Pilih" clearable) 

              v-flex(xs5 sm6)
                  p(class="headerInput") Identifikasi Bahaya dan Pengendalian Resiko 
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-identifikasi" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipIdentifikasi" label="Pilih" clearable) 

              v-flex(xs5 sm6)
                  p(class="headerInput") Daftar pekerja dan kompetensi
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-daftar-pekerjaan" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipDaftarPekerja" label="Pilih" clearable)

              v-flex(xs5 sm6)
                  p(class="headerInput") Daftar sarana prasarana instalasi dan peralatan dan komisioning 
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-daftar-sarana" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipDaftarSarana" label="Pilih" clearable)

              v-flex(xs5 sm6)
                  p(class="headerInput") Standar Operasional Prosedur / Analisa Kerja Aman 
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-standar" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipStandar" label="Pilih" clearable)

              v-flex(xs5 sm6)
                  p(class="headerInput") HSE Plan (Inspeksi, safety talk, observasi & pelatihan keselamatan (emergency drill) 
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-hse" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipHse" label="Pilih" clearable)

              v-flex(xs5 sm6)
                p(class="headerInput") Manajemen Perubahan (MOC)
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-management" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipManajemen" label="Pilih" clearable)  

              v-flex(xs5 sm6)
                p(class="headerInput") Water Management Plan
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-water" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipWater" label="Pilih" clearable)

              v-flex(xs5 sm6)
                p(class="headerInput") Hydrocarbon Management Plan
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-hydrocarbon" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipHydrocarbon" label="Pilih" clearable)

              v-flex(xs5 sm6)
                  p(class="headerInput") Emergency Response Plan  
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-emergency" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipEmergency" label="Pilih" clearable)

              v-flex(xs5 sm6)
                  p(class="headerInput") Surat Penunjukan PJO oleh Direksi
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-surat" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipSurat" label="Pilih" clearable) 
              
              v-flex(xs5 sm6)
                  p(class="headerInput") Pengesahan PJO oleh KTT
              v-flex(xs1 sm2)
              v-flex(xs5 sm3)
                v-select(id="fius-pjo" class="selectInput" :items='checkOptions' v-model="ipSyaratKhusus.ipPengesahanPjo" label="Pilih" clearable)
              
              v-flex(xs5 sm3 style="margin-top:15px" ) 
                h3(class="headerSection") Upload Dokumen
              v-flex(xs6 sm3 class="attachment"  style="margin-top:1px" v-if="!docPendukung || docPendukung.size > 10000000")
                v-file-input(id="fius-document" :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                  template(v-slot:selection="{ text }" )
                    v-chip(small label color="primary")   {{ text }}
              v-flex(xs6 sm3 class="attachmentName"  style="margin-top:15px" v-else-if="(docPendukung)||(docPendukung && docPendukung.size < 10000000)")
                span(id="fius-document") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                  v-icon mdi-close
              v-flex(xs1 sm4)

              v-flex(xs12 sm12 style="margin-top:10px") 
                  h3(class="headerSection") Tindakan Pencegahan Lainnya
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(id="fius-pencegahan" :editor="editor" v-model="ipTindakanLain" :config="editorConfig")
                  br
              
        v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
        v-btn(class="mr-3" color='info' @click='submit(1)')
          v-icon insert_drive_file
          | &nbsp; Save as Draft
        //- v-btn(color='success' @click='submit(2)' :disabled="isPage3Complete")
        v-btn(color='success' @click='submit(2)')
          v-icon send
          | &nbsp; Submit Request
        v-btn(text @click="backHome()") Cancel
</template>

<script>
// import * as config from "../config/index.json";
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
import PemegangModal from "./PemegangModal.vue";
import ModalIzinProyek from './ModalIzinProyek.vue';
export default {
  name: "AddJasa",
  components: {
    PemegangModal,
    ModalIzinProyek
  },
  props: {
    edit: { type: Boolean, default: false },
    syncLocations: Array,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        removePlugins: ["ImageUpload", "MediaEmbed"],
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
        image: {
          // You need to configure the image toolbar, too, so it uses the new style buttons.
          toolbar: [
            "imageTextAlternative",
            "|",
            "imageStyle:alignLeft",
            "imageStyle:full",
            "imageStyle:alignRight",
          ],
          styles: [
            // This option is equal to a situation where no style is applied.
            "full",
            // This represents an image aligned to the left.
            "alignLeft",
            // This represents an image aligned to the right.
            "alignRight",
          ],
        },
      },
      e1: 1,
      formCode: "BIB-HSE-PPO-F-071-02",
      todayDate: new Date().toISOString().slice(0, 10),
      ipJudulPekerjaan: "",
      ipDeptDivisi: "",
      ipDivisi: "",
      ipPerusahaan: "",
      pemegangIzin: "",
      ipJobDescription: "",
      lokasi: [],
      ipSubLocation: '',
      ipTindakanLain: "",
      status: 0,
      ipSyaratKhusus: {
        ipKontrak: "",
        ipSurat: "",
        ipMetodeKerja: "",
        ipIdentifikasi: "",
        ipDaftarPekerja: "",
        ipDaftarSarana: "",
        ipHse: "",
        ipStandar: "",
        ipManajemen: "",
        ipWater: "",
        ipHydrocarbon: "",
        ipEmergency: "",
        ipPengesahanPjo: ""
    },
      searchPemegangMenu: false,
      uploadId: null,
      docPendukung: null,
      startMenu: false,
      endMenu: false,
      startDateExtend: new Date().toISOString().substr(0, 10),
      endDateExtend: new Date().toISOString().substr(0, 10),
      startMenuExtend: false,
      endMenuExtend: false,
      checkOptions: ["Ya", "Tidak"],
      rules: [
        (value) =>
          !value || value.size < 10000000 || "Ukuran file harus dibawah 10 MB!",
      ],
      emptyUpload: new File([""], "", {
        type: "",
      }),
    };
  },
  mounted: async function () {
    this.$store.dispatch("fetchLocations");
    this.uploadId = JSON.stringify(Date.now());
  },
  computed: {
    ...mapState([
      "API_URL",
      "locations",
      "dataUsers",
      "dataEditRequest"
    ]),
    selectedLoc() {
      let tempLoc = [];
      let locationCode;

      if (this.dataUsers.location instanceof Array) {
        locationCode = this.dataUsers.location[0];
      } else {
        locationCode = this.dataUsers.location;
      }

      for (let i = 0; i < this.lokasi.length; i++) {
        tempLoc.push({ code: locationCode, name: this.lokasi[i] });
      }
      return tempLoc;
    },
    isPage1Complete: function () {
      return (
        !!this.ipJudulPekerjaan &&
        !!this.ipDeptDivisi &&
        !!this.ipDivisi &&
        !!this.ipSubLocation &&
        !!this.ipPerusahaan &&
        this.selectedLoc.length != 0 &&
        !!this.pemegangIzin.name &&
        !!this.pemegangIzin.email &&
        !!this.pemegangIzin.ktpNumber &&
        !!this.pemegangIzin.phone &&
        !!this.pemegangIzin.position &&
        !(this.selectedLoc.length < 1)
      );
    },
    isPage3Complete: function () {
      const sk = this.ipSyaratKhusus;
      return !(sk.ipKontrak && 
      sk.ipSurat && 
      sk.ipMetodeKerja &&
      sk.ipIdentifikasi &&
      sk.ipDaftarPekerja &&
      sk.ipDaftarSarana &&
      sk.ipHse &&
      sk.ipStandar &&
      sk.ipEmergency &&
      sk.ipPengesahanPjo);
    }
  },
  methods: {
    updatePemegangIzin(user) {
      this.pemegangIzin = user;
    },
    clearDate() {
      this.endDate = null;
      this.startMenu = false;
    },
    formatDate: helper.formatDate,
    scrollTop() {
      window.scrollTo(0, 0);
    },
    submit(status) {

      this.status = status;
      let formData = {
        ipJudulPekerjaan : this.ipJudulPekerjaan,
        ipPerusahaan : this.ipPerusahaan,
        ipLocation : this.selectedLoc,
        ipSubLokasi : this.ipSubLocation,
        ipPemegangIzin : this.pemegangIzin,
        ipJobDescription : this.ipJobDescription,
        ipSyaratKhusus: {
          ipKontrak: this.ipSyaratKhusus.ipKontrak == null ? "" : this.ipSyaratKhusus.ipKontrak,
          ipSurat: this.ipSyaratKhusus.ipSurat == null ? "" : this.ipSyaratKhusus.ipSurat,
          ipMetodeKerja: this.ipSyaratKhusus.ipMetodeKerja == null ? "" : this.ipSyaratKhusus.ipMetodeKerja,
          ipIdentifikasi: this.ipSyaratKhusus.ipIdentifikasi == null ? "" : this.ipSyaratKhusus.ipIdentifikasi,
          ipDaftarPekerja: this.ipSyaratKhusus.ipDaftarPekerja == null ? "" : this.ipSyaratKhusus.ipDaftarPekerja,
          ipDaftarSarana: this.ipSyaratKhusus.ipDaftarSarana == null ? "" : this.ipSyaratKhusus.ipDaftarSarana,
          ipHse: this.ipSyaratKhusus.ipHse == null ? "" : this.ipSyaratKhusus.ipHse,
          ipStandar: this.ipSyaratKhusus.ipStandar == null ? "" : this.ipSyaratKhusus.ipStandar,
          ipManajemen: this.ipSyaratKhusus.ipManajemen == null ? "" : this.ipSyaratKhusus.ipManajemen, 
          ipWater: this.ipSyaratKhusus.ipWater == null ? "" : this.ipSyaratKhusus.ipWater,
          ipHydrocarbon: this.ipSyaratKhusus.ipHydrocarbon == null ? "" : this.ipSyaratKhusus.ipHydrocarbon,
          ipEmergency: this.ipSyaratKhusus.ipEmergency == null ? "" : this.ipSyaratKhusus.ipEmergency,
          ipPengesahanPjo: this.ipSyaratKhusus.ipPengesahanPjo == null ? "" : this.ipSyaratKhusus.ipPengesahanPjo
        },
        ipStatus : this.status,
        ipUser : this.dataUsers ,
        ipTindakanLain : this.ipTindakanLain,
        ipDeptDivisi:this.ipDeptDivisi,
        ipDivisi : this.ipDivisi,
        ipUploadedDocsId : this.uploadId,
       }
       const isDraftAndEdit = this.edit;
       if (isDraftAndEdit) formData.ipNo = this.ipNo;
      const config = {
        method: "post",
        url: `${this.API_URL}/v1/requests${isDraftAndEdit ? "/editJasa" : "/submitJasa"}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: formData,
      };
      axios(config).then((res) => {
        this.$store.commit("temporaryData", res);
        this.$router.push("/my-permit");
      });
    },

    upload(name, paramFile) {
      if (paramFile == undefined) return;
      if (paramFile.size > 10000000) {
        paramFile = null;
        if (name == "docPendukung") {
          this.docPendukung = this.emptyUpload;
        }
        return;
      } else {
        let formData = new FormData();
        formData.append("uploadId", this.uploadId);
        formData.append(name, paramFile);
        axios.post(`${this.API_URL}/v1/requests/attachment/${name}`, formData, {
          headers: { Authorization: `Bearer ${this.$store.state.token}` },
        });
      }
    },
    deleteDocPendukung(name) {
      let id = this.uploadId.toString();
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    backHome() {
      this.$router.push("/my-permit");
    },
    backStep() {
      this.e1--;
    },
    docName(name) {
      return this.$setFilename(name);
    },
  },
  watch: {
    docPendukung(params){
      if(params && params.size < 10000000){
         let formData = new FormData();
        formData.append('uploadId', this.uploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      }
    },
    dataEditRequest: async function () {
      const  {
        ipJudulPekerjaan, ipSyaratKhusus, ipPemegangIzin, ipLocation,
        ipSubLokasi, ipDeptDivisi,
        ipTindakanLain, ipJobDescription, ipUploadedDocsId,
        ipUploadedDocs, ipDivisi, ipPerusahaan, ipNo
      } = this.dataEditRequest;

      this.ipJudulPekerjaan = ipJudulPekerjaan;
      this.lokasi = ipLocation.map((loc) => loc.name);
      this.ipPerusahaan = ipPerusahaan
      this.ipSubLocation = ipSubLokasi;
      this.pemegangIzin = ipPemegangIzin
      this.ipJobDescription = ipJobDescription;
      this.ipSyaratKhusus = ipSyaratKhusus
      this.ipTindakanLain = ipTindakanLain
      this.ipDeptDivisi = ipDeptDivisi
      this.ipDivisi = ipDivisi
      this.docPendukung = ipUploadedDocs.docPendukung;
      this.uploadId = ipUploadedDocsId;
      this.ipNo = ipNo;

    },
  },
};
</script>

<style>
.blackFont {
  color: black;
}
.redFont {
  color: red;
}
.blueFont {
  color: blue;
}
.ck-editor__editable {
  min-height: 300px;
  max-height: 300px;
  resize: none;
}
.mustFill {
  color: #ea5164;
}
</style>
